import type {
  RecordFactory,
  RecordOf,
}                 from 'immutable';
import { Record } from 'immutable';

// Use RecordFactory<TProps> for defining new Record factory functions.
type LocationProps = {|
  pathname: string,
  search: string,
  hash: string,
  key: string,
|};

const defaultValues: LocationProps = {
  pathname: '',
  search:   '',
  hash:     '',
  key:      '',
};

export const makeLocation: RecordFactory<LocationProps> = Record(defaultValues);

export type LocationRecord = RecordOf<LocationProps>;



// WEBPACK FOOTER //
// ./src/modules/react-router/domain/react-router.domain.js